import axios, { AxiosInstance } from 'axios';


const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_ALPHALINK_API_BASE_URL || 'http://127.0.0.1:8080',
});

export const AXIOS_: AxiosInstance = axiosInstance;
